import React from 'react'
import s from './NotificationDot.less'

const NotificationDot = ({ top, left, size = 8 }) => (
  <span className={s.dot} style={{ top, left, borderRadius: size / 2, width: size, height: size }}></span>
)

export default NotificationDot
